module.exports = __webpack_public_path__ + "img/UltrackELDscreen.fb0d1d7e.jpg";